window.scrollspy = {}

/*
 * Is In Viewport
 * determine wether an element is visibile on the device to run certain functionality
 * $(my-selector).isInViewport()
 * @return bool
 */
$.fn.isInViewport = function() {
    const elementTop = $(this).offset().top
    const elementBottom = elementTop + $(this).outerHeight()
    const viewportTop = $(window).scrollTop()
    const viewportBottom = viewportTop + $(window).height()
    return elementBottom > viewportTop && elementTop < viewportBottom
}

$(document).ready(() => {
    /*
     * Scrollspy
     */
    // gather scrollspy elements and push to window.scrollspy object
    $.each($('.scrollspy'), (i, el) => {
        const id  = $(el).attr('id')
        const top = $(el).offset().top
        const bot = top + $(el).height()
        window.scrollspy[`#${id}`] = { top, bot }
    })
    // handle scrollspy anchors scroll animation
    $('[href^="#"]').on('click touch', function (e) {
        const href = $(this).attr('href')
        if (href in window.scrollspy) {
            e.preventDefault()
            $([document.documentElement,document.body]).animate({
                scrollTop: window.scrollspy[href].top
            }, 500)
        }
        return
    })
    // activate scrollspy anchors based on current window scroll position
    $(window).on('load resize scroll', () => {
        const scrollPosY = window.scrollY
        $.each($('.scrollspy'), (i, el) => {
            const id = $(el).attr('id')
            const anchor = `#${id}`
            const scroll = window.scrollspy[anchor]
            if (scrollPosY >= (scroll.top - 5) && scrollPosY <= (scroll.bot - 5)) {
                $(`[href="${anchor}"]`).parent().addClass('scrollspy--active').siblings().removeClass('scrollspy--active')
            }
        })
    })
})

